import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animation } from '../constants/animation';
import { BLANK_BACKGROUND, COLOUR_MAPPINGS } from '../constants/background';
import { BLANK, DARK, DEFAULT, SHADE } from '../constants/useOptions';
import { getBackground } from '../operators/getBackground';
import { getSize } from '../operators/getSize';
import { jsx as _jsx } from "react/jsx-runtime";
// Default props
const DEFAULT_USE = DEFAULT;
const SkeletonBaseInner = styled.div.withConfig({
  displayName: "SkeletonBase__SkeletonBaseInner",
  componentId: "kqz9lw-0"
})(["position:relative;margin:", ";padding:", ";", ";width:100%;overflow:hidden;z-index:1;&::after{content:' ';display:block;position:absolute;top:0;left:0;right:0;height:100%;transform:translateX(-100%);", ";", "}"], ({
  margin
}) => getSize(margin), ({
  padding
}) => getSize(padding), ({
  use = DEFAULT_USE
}) => use === BLANK ? BLANK_BACKGROUND : `background: ${COLOUR_MAPPINGS[use].primary}`, ({
  use = DEFAULT_USE
}) => use !== BLANK && animation, ({
  use = DEFAULT_USE
}) => use !== BLANK && getBackground({
  use
}));

/**
 * @deprecated This component is not tokenized. Replace with SkeletonView, SkeletonText, SkeletonContainer, or SkeletonCircle.
 */
const SkeletonBase = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SkeletonBaseInner, Object.assign({
    "data-loading": "true"
  }, rest, {
    children: children
  }));
};
SkeletonBase.displayName = 'SkeletonBase';
SkeletonBase.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  use: PropTypes.oneOf([DEFAULT, SHADE, DARK, BLANK])
};
export default SkeletonBase;